module.exports = __webpack_public_path__ + "img/フォルダ.808f5fe2.svg";